export default "__VITE_ASSET__0af24fce__"